import React from 'react';
import notification from '../../../notification';
import ValidationError from './validation-error';

const normalizeToMessageArray = (messages: unknown): string[] => {
  if (messages == null) return [];
  if (Array.isArray(messages))
    return messages.filter((m): m is string => typeof m === 'string');
  if (typeof messages === 'string') return [messages];
  if (typeof messages === 'object') {
    return (
      (Object.values(messages) as unknown[])
        ?.flat()
        ?.filter((m): m is string => typeof m === 'string') ?? []
    );
  }
  return [];
};

export const showValidationErrorNotification = (messages: unknown) => {
  const list = normalizeToMessageArray(messages);
  notification.error({
    header: 'Validation Error!',
    content: <ValidationError messages={list} />,
  });
};
